export const BLOG_POSTS = [
  {
    slug: 'choose-perfect-rakhi',
    title: 'How to choose the perfect rakhi for your brother',
    excerpt: 'A simple guide to style, tradition and gifting the right rakhi for every personality.',
    date: '2025-05-01',
    sections: [
      {
        heading: 'Know his style',
        body: 'Traditional thread rakhi suits classic tastes; bracelet rakhis work well for younger brothers who prefer everyday wear.',
      },
      {
        heading: 'Festival timing',
        body: 'Order early during Raksha Bandhan season so you have time for personalization on name bracelets.',
      },
    ],
  },
  {
    slug: 'lumba-wedding-style',
    title: 'Styling your Lumba for wedding celebrations',
    excerpt: 'Discover elegant lumba styling ideas for wedding festivities — from mehendi and sangeet to festive gifting.',
    date: '2025-04-12',
    sections: [
      {
        heading: 'Colour and outfit',
        body: 'Match lumba tones to the saree or lehenga — gold and maroon are timeless for wedding functions.',
      },
      {
        heading: 'Festive occasions',
        body: 'Pair statement lumba with lighter outfits for mehendi, and richer kundan or mirror work for sangeet and reception looks.',
      },
    ],
  },
  {
    slug: 'handcrafted-jewelry',
    title: 'Why handcrafted jewelry feels more personal',
    excerpt: 'Learn why every piece of Saloni Designs is made with care and a story behind it.',
    date: '2025-03-20',
    sections: [
      {
        heading: 'Made in Ahmedabad',
        body: 'Each rakhi and lumba is finished by hand in our studio, so no two pieces are exactly alike.',
      },
    ],
  },
];
